module.exports = __webpack_public_path__ + "static/img/cross_icon.23e34c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cross_icon.png
// module id = pvED
// module chunks = 2